import { render, staticRenderFns } from "./CreateTenderTable.vue?vue&type=template&id=c6deae38&scoped=true&"
import script from "./CreateTenderTable.vue?vue&type=script&lang=js&"
export * from "./CreateTenderTable.vue?vue&type=script&lang=js&"
import style0 from "./CreateTenderTable.vue?vue&type=style&index=0&id=c6deae38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6deae38",
  null
  
)

export default component.exports